export default __webpack_public_path__ + "static/media/isreal.24c7ca83.png";